import React from "react";
import { RelatorioComposicaoContasItem } from "core/features/relatorios/conta-com-composicoes/typings";
import { View, Text } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "components/Relatorio/styles";
import { PDFTable } from "ui/components/PDF";
import useRelatorioComposicaoContasPdfColumns from "./hooks/useRelatorioComposicaoContasPdfColumns";
import TotalRow from "../TotalRow";
import { OperacaoEnum } from "resources/enums/conta";
import { RelatorioContasComComposicaoFields } from "core/features/relatorios/typings";
import { formatBlocoQuadra } from "infra/helpers/formatBlocoQuadra";
interface PDFRelatorioComposicaoReceitasItemTableProps {
  item: RelatorioComposicaoContasItem;
  operacao: OperacaoEnum;
  fields?: RelatorioContasComComposicaoFields[];
}

function ItemTable({
  item,
  operacao,
  fields,
}: PDFRelatorioComposicaoReceitasItemTableProps) {
  const columns = useRelatorioComposicaoContasPdfColumns(operacao, fields);

  return (
    <View>
      <View style={commonRelatorioPdfStyles.itemTableTitleRow}>
        <Text style={commonRelatorioPdfStyles.itemTableTitle}>
          {item.unidade
            ? formatBlocoQuadra(item.unidade, item.blocoQuadra, "") + " - "
            : ""}
          {item.nome}
        </Text>
        {item.pessoaOperadorAcordo?.nome ? (
          <Text style={{ ...commonRelatorioPdfStyles.itemTableTitle, marginLeft: "auto" }}>
            Operador do acordo: {item.pessoaOperadorAcordo.nome}
          </Text>
        ) : null}
      </View>
      <PDFTable
        data={item.composicoes}
        columns={columns}
        tableHeaderVariant="rowLike"
      />
      <View style={commonRelatorioPdfStyles.itemTableSummary}>
        <TotalRow title="Total" valorTotal={item.valorTotal} />
      </View>
    </View>
  );
}

export default ItemTable;
